import {getLabel} from "./lang-utils.ts";

type PropTypes = {
    name: string
}
const GetLabel = (props: PropTypes) => {
    return getLabel(props.name);
};

export default GetLabel;